import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// @atlaskit
import { AkSearchDrawer } from '@atlaskit/navigation';
import { QuickSearch, ResultItemGroup, ResultBase } from '@atlaskit/quick-search';

// @source
import { Messages } from '..';
import { crypto } from '../../../utils';
import { PrimaryIcon, DrawerBackButton } from './Similar';
import { Search } from '../../../server';

const initialState = {
  isLoading: false,
  message: false,
  results: [],
  value: '',
};

class SearchDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.onChangeHandle = this.onChangeHandle.bind(this);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  onChangeHandle(event) {
    this.setState({ value: event.target.value });
  }

  onSubmitHandle() {
    this.setState({
      isLoading: true,
      message: false,
      results: [],
    });

    Search({
      data: {
        search: this.state.value,
      },
      success: (results) => {
        this.setStateUnmount({
          isLoading: false,
          results,
        });
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    return (
      <AkSearchDrawer
        backIcon={DrawerBackButton()}
        isOpen={this.props.isOpen}
        onBackButton={this.props.onBackHandle}
        primaryIcon={PrimaryIcon}
      >
        <QuickSearch
          isLoading={this.state.isLoading}
          onSearchInput={this.onChangeHandle}
          onSearchSubmit={this.onSubmitHandle}
          placeholder="Write your report name..."
        />
        {this.state.results.map(({ Title, Rules }) => (
          <ResultItemGroup key={Title} title={Title}>
            {Rules.map(text => (
              <Link
                key={text}
                to={`/reports/edit/${crypto.encode(text)}`}
              >
                <ResultBase text={text} />
              </Link>
            ))}
          </ResultItemGroup>
        ))}
        {this.state.message}
      </AkSearchDrawer>
    );
  }
}

SearchDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onBackHandle: PropTypes.func.isRequired,
};

SearchDrawer.defaultProps = {
  isOpen: false,
};

export default SearchDrawer;
